export const plans = [
  {
    title: "Authors Night",
    desc: "Meet featured BooClub authors and collect signed editions.",
    author: "James Patterson",
    date: "May 10, 2026",
    location: "Seoul, Korea",
    img: "/img/library-2.jpg",
  },
  {
    title: "Young Authors Summit",
    desc: "A prestigious competition for emerging literary voices.",
    author: "James Patterson",
    date: "May 15, 2026",
    location: "New York, USA",
    img: "/img/library-3.jpg",
  },
  {
    title: "Community Review Week",
    desc: "Share reviews, earn likes, and climb Active Readers.",
    author: "BooClub Desk",
    date: "June 1, 2026",
    location: "Online",
    img: "/img/library-5.jpg",
  },
  {
    title: "Map Tour",
    desc: "Visit partner bookstore locations on our Products map.",
    author: "Locations",
    date: "Ongoing",
    location: "Partner stores",
    img: "/img/library-6.jpg",
  },
];
